<template>
  <b-form-group
    label="Tutar"
    label-for="amount"
  >
    <validation-provider
      #default="{ errors }"
      name="Tutar"
      rules="required"
    >
      <b-input-group>
        <cleave
          id="amount"
          v-model="dataItem.amount"
          class="form-control"
          :raw="true"
          :options="options.float"
          placeholder="Tutar"
        />
        <b-input-group-append is-text>
          ₺
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'

export default {
  name: 'Title',
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    Cleave,
  },
  data() {
    return {
      required,
      options: {
        float: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['promissories/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
